import { render, staticRenderFns } from "./indexs.vue?vue&type=template&id=5e961ec6&scoped=true"
import script from "./indexs.vue?vue&type=script&lang=js"
export * from "./indexs.vue?vue&type=script&lang=js"
import style0 from "./indexs.vue?vue&type=style&index=0&id=5e961ec6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e961ec6",
  null
  
)

export default component.exports